import { Navigate } from "react-router-dom";
import Client from "../Client";
import { encodeParams } from "../misc/path";
import { ALL_ROUTES } from "./_routes";



export const MainRouter = {
    navigate: () => {},

    /** @type {{ [key: string]: (Function | { roles?: string[], view: Function }) }} */
    routes: ALL_ROUTES,

    listRoutes() {
        const routes = [];
        for(const path in this.routes) {
            let _route = this.routes[path];
            const route = typeof(_route) === "function" ? { view: _route } : _route;

            const viewWall = () => {
                if(route.roles) {
                    const targetPath = window.location.pathname + window.location.search;
                    if(!Client.ensureSignedIn({ throwing: false })) 
                        return <Navigate to={`/login?${encodeParams({ redirect: targetPath })}`} />;
    
                    const accountRole = Client.account.role;
                    if(!route.roles.includes(accountRole)) return <Unauthorized />;
                }
                const View = route.view;
                return <View args={route.args} />;
            };

            routes.push([path, { ...route, view: viewWall }]);
        }

        return routes;
    },

    pushPath(path) {
        window.history.replaceState({}, null, path);
    },

    goto(path) {
        this.navigate(path);
    },

    shift(path) {
        this.navigate(path, { replace: true });
    },

    back() {
        this.navigate(-1);
    }
};



function Unauthorized() {
    return (<div>Unauthorized</div>);
}

